export default "__VITE_ASSET__6e3c6f42__"